"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateImageId = exports.createTextPlaceholder = exports.createSVGImageData = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var createTextPlaceholder = exports.createTextPlaceholder = function createTextPlaceholder(content) {
  return "<span data-placeholder=\"true\">".concat(content, "</span>");
};
var generateImageId = exports.generateImageId = function generateImageId() {
  return (0, _v["default"])();
};
var createSVGImageData = exports.createSVGImageData = function createSVGImageData() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fileName = options.fileName,
    imageUrl = options.imageUrl,
    thumbUrl = options.thumbUrl,
    _options$operations = options.operations,
    operations = _options$operations === void 0 ? {} : _options$operations,
    _options$galleryImage = options.galleryImage,
    galleryImage = _options$galleryImage === void 0 ? true : _options$galleryImage,
    _options$isPlaceHolde = options.isPlaceHolderImage,
    isPlaceHolderImage = _options$isPlaceHolde === void 0 ? false : _options$isPlaceHolde,
    _options$svgImageSize = options.svgImageSize,
    svgImageSize = _options$svgImageSize === void 0 ? {
      width: 290,
      height: 290
    } : _options$svgImageSize;
  return {
    fileName: fileName,
    identifier: generateImageId(),
    originalFileName: imageUrl,
    original: _objectSpread({
      url: null,
      format: 'SVG',
      mimeType: 'image/svg+xml'
    }, svgImageSize),
    preview: _objectSpread({
      url: imageUrl,
      format: 'SVG',
      mimeType: 'image/svg+xml'
    }, svgImageSize),
    thumbnail: {
      url: thumbUrl,
      format: 'PNG',
      mimeType: 'image/png',
      width: 160,
      height: 160
    },
    message: null,
    gallery: galleryImage,
    isPlaceHolderImage: isPlaceHolderImage,
    operations: operations
  };
};